import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function SiteRectifierGraph() {
    const { id, rid } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        navigate(`/site/${id}/rectifier/${rid}`, { replace: true, state: { tab: "graph" } });
    }, [id, rid, navigate]);

    return null;
}
